<template>
    <div>
      <div class="web-only landing">
        <div
          class="row web-only"
          style="
            color: #1f4e78;
            padding-top: 60px;
            padding-bottom: 60px;
            padding-left: 7%;
            padding-right: 7%;
            width: 100%;
            background-color: white;
            margin-left: 0;
          "
        >
          <div class="col-lg-6 col-md-6 px-3" style="margin-top: auto; margin-bottom: auto;">
            <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
                The all-in-one software system for<br>au pair agency management
            </h1>
            <!-- <div class="web-only">
              <h3 style="margin-bottom: 4px;">Run your agency smarter with a software solution designed just for you. Your clients and candidates will love it.</h3>
            </div> -->
            <!-- <p style="font-size: 1.25rem; margin-top: 15px; margin-bottom: 2px;">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p> -->
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 25px;
                margin-bottom: 25px;
              ">
              From the moment a family arrives on your website to the moment your au pair walks into their home, and everything in between, power your agency with the truly all-in-one platform that takes care of your entire process. 
            </h2>
            <!-- <h2 style="
                font-size: 1.25rem;
                line-height: 1.35;
                margin-top: 5px;
                margin-bottom: 35px;
              ">
              Do you wonder how other agencies offer multiple services and manage multiple locations? Read on!
            </h2> -->
            <em
            style=""
            class="mb-4"
            >We are proud members of</em>
            </br>
            <img
              src="../assets/img/associations/IAPA.png"
              width="40%"
              height=""
              class="mt-3"
            />
            <!-- maternity nurse https://www.instagram.com/nannyskye/ -->

            <!-- <p style="font-size: 1.2rem; margin-bottom: 2px;">Offer candidates and clients a seamless experience and</p> -->
            <!-- <p style="font-size: 1.2rem;" class="mb-5">establish your brand as the go to for your niche.</p> -->
  
            <!-- <div class="mt-5">
              <router-link
                :to="{ name: 'Get Started' }"
                class="mylisting-button light-button"
              >Get Started</router-link>
              <router-link
                :to="{ name: 'Book Demo' }"
                class="mylisting-button light-button"
              >Learn More</router-link>
            </div> -->

            <!-- <a class="mylisting-button dark-button" href="https://myportfolio.enginehire.io/candidates/KPMxBg2oVL1WAQwy" target="_blank">Check Out An Example</a> -->
          </div>
          <div
            class="col-lg-6 col-md-6 web-only px-3"
            style=""
          >
            <img
              src="../assets/img/mobileapp/mobile hero aupair v2.svg"
              width="100%"
              height=""
              class=""
            />
  
            <!-- <transition
              name="message"
              mode="out-in"
            >
              <template v-for="(message, index) of listMessages">
                <div
                  :key="'message-' + index"
                  class=""
                  v-if="messageCount === index + 1"
                >
                  <img
                    :src="
                      require(`../assets/img/home/${message.img}`)
                    "
                    width=""
                    height=""
                    class=""
                  />
                </div>
              </template>
            </transition> -->
          </div>
        </div>
      </div>
  
      <div class="mobile-only mobile-landing">
        <div
          class=""
          style="
            color: #1f4e78;
            padding-top: 6vh;
            padding-bottom: 0px;
            padding-left: 5%;
            padding-right: 5%;
            width: 100%;
            background-color: white;
          "
        >
          <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
          <h1
            style="font-weight: 900; margin-bottom: 15px"
            class="center"
          >
            The all-in-one software<br>system for au pair<br>agency management
          </h1>
          <div class="">
            <h4
              style="margin-bottom: 30px; line-height: 1.35; font-weight: 400;"
              class="center"
            >
            From the moment a family arrives on your website to the moment your au pair walks into their home, and everything in between, power your agency with the truly all-in-one platform that takes care of your entire process. 
            </h4>
            <!-- <h3>solo and small staffing operations.</h3> -->
          </div>

          <!-- <div class="center" style="margin-top: 30px; margin-bottom: 30px;">
            <a class="mylisting-button dark-button" href="https://myportfolio.enginehire.io/candidates/KPMxBg2oVL1WAQwy" target="_blank">Check Out An Example</a>
          </div> -->

          <!-- <img
                src="../assets/img/home/AdobeStock_601258960_cropped.jpg"
                width="90%"
                height=""
                class="my-auto pt-4 center"
            /> -->
        <img
              src="../assets/img/mobileapp/mobile hero aupair v2.svg"
              width="100%"
              height=""
              class="center mt-4 mb-4"
            />

          <!-- <h4
              style="padding-bottom: 40px; line-height: 1.35"
              class="center"
            >
              Do you wonder how other agencies offer multiple services and manage multiple locations? Read on!
            </h4> -->

          <em
          style=""
          class="mt-5 mb-1 center"
          >We are proud members of</em>
          </br>
          <img
            src="../assets/img/associations/IAPA.png"
            width="80%"
            height=""
            class="mb-5 center"
          />

          <!-- <p style="margin-bottom: 2px;" class="center">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p> -->
          <!-- <p style="font-size: 1.2rem; margin-bottom: 2px;">Offer candidates and clients a seamless experience and</p> -->
          <!-- <p style="font-size: 1.2rem;" class="mb-5">establish your brand as the go to for your niche.</p> -->
        </div>
      </div>

      <div class="" style="">
        <div
          class="row mb-5"
          style="padding-left: 7%; padding-right: 7%; margin-right: 0;"
        >
          
          <div
            class="col-lg-6"
            style="margin-top: auto; margin-bottom: auto;"
          >
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
                The process begins with a fully customized family registration form
            </h1>
            <!-- <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Gather whatever information you need from the family
            </h2> -->
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              The system supports any language, so families and au pairs can choose the language they want to use
            </h2>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              All new family inquiries will appear in your branded agency dashboard
            </h2>
          </div>
          <div
            class="col-lg-6"
            style=""
          >
            <div
                class="small-carousel"
                style=""
            >
            <CarouselImageComponent
                :listItems="listClientReg"
                :itemPerPage="1"
            />
            </div>
            <div
                class="tiny-carousel px-2"
                style=""
            >
            <CarouselImageComponent
                :listItems="listClientReg"
                :itemPerPage="1"
            />
            </div>
          </div>
        </div>




        <div
          class="row mb-5"
          style="padding-left: 7%; padding-right: 7%; margin-right: 0;"
        >
          <div
            class="col-lg-6"
            style=""
          >
            <div
                class="small-carousel"
                style=""
            >
            <CarouselImageComponent
                :listItems="listClientMeeting"
                :itemPerPage="1"
            />
            </div>
          </div>
          <div
            class="col-lg-6"
            style="margin-top: auto; margin-bottom: auto;"
          >
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
                Arrange a meeting to learn more about the family
            </h1>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              The system will handle all of your communication, sending out a booking calendar, and automated follow ups and reminders so you never lose a lead
            </h2>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              During the meeting use the side by side view with a custom template of questions to update the family file and take your notes at the same time
            </h2>
          </div>
          <div
            class="col-lg-6"
            style=""
          >
            <div
                class="tiny-carousel px-2"
                style=""
            >
            <CarouselImageComponent
                :listItems="listClientMeeting"
                :itemPerPage="1"
            />
            </div>
          </div>
        </div>



        <div
          class="row mb-5"
          style="padding-left: 7%; padding-right: 7%; margin-right: 0;"
        >
          
          <div
            class="col-lg-6"
            style="margin-top: auto; margin-bottom: auto;"
          >
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
                If the family is ready to move forward
            </h1>
            <!-- <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Gather whatever information you need from the family
            </h2> -->
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Every family has a personal page through your agency where they can sign agreements, securely upload documents, and make payments
            </h2>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Families can enrich their profile with additional information and rich multimedia like video recordings and photo galleries
            </h2>
          </div>
          <div
            class="col-lg-6"
            style=""
          >
            <div
                class="small-carousel"
                style=""
            >
            <CarouselImageComponent
                :listItems="listClientProfile"
                :itemPerPage="1"
            />
            </div>
            <div
                class="tiny-carousel px-2"
                style=""
            >
            <CarouselImageComponent
                :listItems="listClientProfile"
                :itemPerPage="1"
            />
            </div>
          </div>
        </div>



        <div
          class="row mb-5"
          style="padding-left: 7%; padding-right: 7%; margin-right: 0;"
        >
          <div
            class="col-lg-6"
            style=""
          >
            <div
                class="small-carousel"
                style=""
            >
            <CarouselImageComponent
                :listItems="listJobPosting"
                :itemPerPage="1"
            />
            </div>
          </div>
          <div
            class="col-lg-6"
            style="margin-top: auto; margin-bottom: auto;"
          >
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
                Create a posting
            </h1>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Like a job posting you can create a post about the opportunity, which can be automatically shared on your website to attract au pairs
            </h2>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              This posting can be broadcasted to your au pair database and/or partner agencies you work with
            </h2>
          </div>
          <div
            class="col-lg-6"
            style=""
          >
            <div
                class="tiny-carousel px-2"
                style=""
            >
            <CarouselImageComponent
                :listItems="listJobPosting"
                :itemPerPage="1"
            />
            </div>
          </div>
        </div>




        <div
          class="row mb-5"
          style="padding-left: 7%; padding-right: 7%; margin-right: 0;"
        >
          <div
            class="col-lg-6"
            style="margin-top: auto; margin-bottom: auto;"
          >
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
              Manage Au Pairs
            </h1>
            <!-- <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Gather whatever information you need from the family
            </h2> -->
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Create a custom application form for au pairs, including education, work history, references, etc.
            </h2>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Au pairs appear in your database and you can move them through your process: interviewing, documentation, reference checking, background checking and more
            </h2>
            <!-- <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Partner agencies can submit au pairs to you, you can easily keep track of who came from where
            </h2> -->
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Every au pair, has a beautiful, customizable portfolio which can be shared with families
            </h2>
          </div>
          <div
            class="col-lg-6"
            style=""
          >
            <div
                class="small-carousel"
                style=""
            >
            <CarouselImageComponent
                :listItems="listCandidatePortfolios"
                :itemPerPage="1"
            />
            </div>
            <div
                class="tiny-carousel px-2"
                style=""
            >
            <CarouselImageComponent
                :listItems="listCandidatePortfolios"
                :itemPerPage="1"
            />
            </div>
          </div>
        </div>



        <div
          class="web-only center px-2 mb-5"
          style="
            background-color: var(--coredarkcolor);
            margin-top: 0px;
            margin-bottom: 0px;
            padding-top: 60px;
            padding-bottom: 70px;
            color: white;
          "
        >
          <div style="padding-left: 7%; padding-right: 7%;">
            <!-- <h5 style="color: white; margin-bottom: 35px">
              Want to learn more and see how it works?
            </h5> -->
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
              Seamless Flow With Partner Agencies 
            </h1>
            <h2 style="
                  font-size: 1.5rem;
                  line-height: 1.35;
                  margin-top: 20px;
                  margin-bottom: 40px;
                ">
                Agencies you work with in other countries can easily submit au pairs and family information to you! You can seamlessly keep track of who came from where, and also send your information to them.
            </h2>
            <div class="mt-3">
              <!-- <router-link
                :to="{ name: 'Demo Video' }"
                class="mylisting-button light-button mx-1"
                target="_blank"
              >Watch the 3 Minute Demo</router-link> -->
              <router-link
                :to="{ name: 'Meet Alejandro' }"
                class="mylisting-button light-button mx-1"
              >Learn More</router-link>
            </div>
            <!-- <h5 style="color: white; margin-top: 44px">
              <em>Are you a new agency? Ask about our startup pricing!</em>
            </h5> -->
          </div>
        </div>

        <div
          class="mobile-only center px-4 mb-5"
          style="
            background-color: var(--coredarkcolor);
            margin-top: 0px;
            margin-bottom: 0px;
            padding-top: 60px;
            padding-bottom: 70px;
            color: white;
          "
        >
        <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
              Seamless Flow With Partner Agencies 
            </h1>
            <h2 style="
                  font-size: 1.5rem;
                  line-height: 1.35;
                  margin-top: 20px;
                  margin-bottom: 40px;
                ">
                Agencies you work with in other countries can easily submit au pairs and family information to you! You can seamlessly keep track of who came from where, and also send your information to them.
            </h2>
            <div class="mt-3">
              <!-- <router-link
                :to="{ name: 'Demo Video' }"
                class="mylisting-button light-button mx-1"
                target="_blank"
              >Watch the 3 Minute Demo</router-link> -->
              <router-link
                :to="{ name: 'Meet Alejandro' }"
                class="mylisting-button light-button mx-1"
              >Learn More</router-link>
            </div>
        </div>




        <div
          class="row mb-5"
          style="padding-left: 7%; padding-right: 7%; margin-right: 0;"
        >
          <div
            class="col-lg-6"
            style=""
          >
            <div
                class="small-carousel"
                style=""
            >
            <CarouselImageComponent
                :listItems="listCandidatePresentation"
                :itemPerPage="1"
            />
            </div>
          </div>
          <div
            class="col-lg-6"
            style="margin-top: auto; margin-bottom: auto;"
          >
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
              Match Au Pairs with the family
            </h1>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Hand select the au pairs you want to share with the family, including a description of why you think they are the right fit
            </h2>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Families can view au pair profiles (concealing any sensitive information) and let you know if they are interested or not interested
            </h2>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              If a family is interested, the system helps you arrange an interview with the au pair, or they can even securely chat through the system if you'd like (you can see all conversations)
            </h2>
          </div>
          <div
            class="col-lg-6"
            style=""
          >
            <div
                class="tiny-carousel px-2"
                style=""
            >
            <CarouselImageComponent
                :listItems="listCandidatePresentation"
                :itemPerPage="1"
            />
            </div>
          </div>
        </div>




        <div
          class="row mb-5"
          style="padding-left: 7%; padding-right: 7%; margin-right: 0;"
        >
          <div
            class="col-lg-6"
            style="margin-top: auto; margin-bottom: auto;"
          >
            <h1 style="font-weight: 900; margin-bottom: 12px; font-size: 2rem;">
              Complete the Placement
            </h1>
            <!-- <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Gather whatever information you need from the family
            </h2> -->
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              If the family is ready to move forward, the system will guide all parties through next steps, documentation requirements, etc. 
            </h2>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Collect your placement fees
            </h2>
            <h2 style="
                font-size: 1.5rem;
                line-height: 1.35;
                margin-top: 20px;
                margin-bottom: 5px;
              ">
              Have an automated schedule of check-ins and follow ups before, during and after the placement to ensure everyone has a smooth experience!
            </h2>
          </div>
          <div
            class="col-lg-6"
            style=""
          >
            <div
                class="small-carousel"
                style=""
            >
            <CarouselImageComponent
                :listItems="listCompletePlacement"
                :itemPerPage="1"
            />
            </div>
            <div
                class="tiny-carousel px-2"
                style=""
            >
            <CarouselImageComponent
                :listItems="listCompletePlacement"
                :itemPerPage="1"
            />
            </div>
          </div>
        </div>
      </div>

      <!-- <div class="mobile-only">
        <div
          class=""
          style="padding-left: 7%; padding-right: 7%; padding-top: 50px; padding-bottom: 5%;"
        >
          <h2>
            Every booking comes into a beautiful, powerful master calendar for you and your admins
          </h2>
          <h4 class="mt-4" style="line-height: 1.3;">Know exactly what's going on every day </h4>
        </div>
        <img src="../assets/img/newborn/master_calendar.png" alt="" style="width: 100%;">
      </div> -->

      <div
        class="web-only center px-2 mb-5"
        style="
          background-color: var(--coredarkcolor);
          margin-top: 0px;
          margin-bottom: 0px;
          padding-top: 60px;
          padding-bottom: 70px;
        "
      >
        <h5 style="color: white; margin-bottom: 35px">
          <em>Want to learn more and see how it works?</em>
        </h5>
        <div class="mt-3">
          <!-- <router-link
            :to="{ name: 'Demo Video' }"
            class="mylisting-button light-button mx-1"
            target="_blank"
          >Watch the 3 Minute Demo</router-link> -->
          <router-link
            :to="{ name: 'Meet Alejandro' }"
            class="mylisting-button light-button mx-1"
          >Let's Talk!</router-link>
        </div>
        <!-- <h5 style="color: white; margin-top: 44px">
          <em>Are you a new agency? Ask about our startup pricing!</em>
        </h5> -->
      </div>

      <div
        class="mobile-only center px-2"
        style="
          background-color: var(--coredarkcolor);
          margin-top: 0px;
          margin-bottom: 0px;
          padding-top: 60px;
          padding-bottom: 70px;
        "
      >
        <h5 style="color: white; margin-bottom: 30px">
          <em>Want to learn more?</em>
        </h5>
        <div class="mt-3">
          <!-- <router-link
            :to="{ name: 'Demo Video' }"
            class="mylisting-button light-button mx-1"
            target="_blank"
          >Watch the 3 Minute Demo</router-link> -->
          <router-link
            :to="{ name: 'Meet Alejandro' }"
            class="mylisting-button light-button mx-1"
          >Let's Talk!</router-link>
        </div>
      </div>


      <div
        class="web-only"
        style="padding-left: 7%; padding-right: 7%; margin-top: 75px;"
      >
        <h4 class="center">Discover why hundreds of agencies love and trust Enginehire</h4>
        <h5 class="center">We can easily transfer your information from any existing system and integrate with any website! </h5>
        <div
          class="mb-5 big-carousel"
          style="margin-top: 25px"
        >
          <CarouselComponent
            :listItems="listTestimonial"
            :itemPerPage="3"
          />
        </div>
        <div
          class="mb-5 medium-carousel"
          style="margin-top: 75px"
        >
          <CarouselComponent
            :listItems="listTestimonial"
            :itemPerPage="2"
          />
        </div>
      </div>
  
      <div class="center web-only">
        <a
              href="https://www.google.com/search?authuser=1&q=Enginehire&stick=H4sIAAAAAAAAAONgU1IxqDAxTUxMTjaySDNMMTEzSTO1MqgwMzZKTjEwS0tJBTLSTBexcrnmpWfmpWZkFqUCAOL_WSk1AAAA&mat=CWuSl5VloDTK&ved=2ahUKEwjX45yUmqiAAxW_mYkEHQPkAuUQrMcEegQIDRAH#lrd=0x45aacc28f1d464f5:0x632cd06fde32cf5,1,,,,"
              target="_blank"
            >
              <img
                src="../assets/img/home/landing/googlereviews2.jpg"
                alt=""
                class="association-logo mx-3"
              >
            </a>
            <a
              href="https://www.g2.com/products/enginehire/reviews"
              target="_blank"
            >
              <img
                src="../assets/img/home/landing/G2reviews.png"
                alt=""
                class="association-logo mx-3"
              >
            </a>
      </div>
  
      <!-- <div
        class="web-only"
        style="padding-left: 7%; padding-right: 7%"
      >
        <div
          class="row"
          style="max-width: 1000px; margin-left: auto; margin-right: auto; margin-top: 70px;"
        >
          <div
            class="col customer-logo-container"
            v-for="(agency, index) of listAgencies"
            :key="'agency-' + index"
          >
            <a
              :href="agency.url"
              target="_blank"
            >
              <img
                :src="require(`../assets/img/home/customer_logos/${agency.logo}`)"
                width=""
                height=""
                :alt="agency.alt"
                class="customer-logo"
              />
            </a>
          </div>
        </div>
      </div> -->
  
      <div
        class="mobile-only"
        style="
          padding-top: 50px;
          padding-bottom: 0px;
          padding-left: 2%;
          padding-right: 2%;
        "
      >
        <h4 class="center px-3 mb-3" style="line-height: 1.4;">Discover why hundreds of agencies love and trust Enginehire</h4>
        <h5 class="center px-3" style="line-height: 1.4;">We can easily transfer your information from any existing system and integrate with any website! </h5>
        <div class="small-carousel">
          <CarouselComponent
            :listItems="listTestimonial"
            :itemPerPage="1"
          />
        </div>
        <div class="tiny-carousel">
          <CarouselComponent
            :listItems="listTestimonial"
            :itemPerPage="1"
            :navigationEnabled="false"
          />
        </div>
  
        <div class="center pt-4">
        <a
              href="https://www.google.com/search?authuser=1&q=Enginehire&stick=H4sIAAAAAAAAAONgU1IxqDAxTUxMTjaySDNMMTEzSTO1MqgwMzZKTjEwS0tJBTLSTBexcrnmpWfmpWZkFqUCAOL_WSk1AAAA&mat=CWuSl5VloDTK&ved=2ahUKEwjX45yUmqiAAxW_mYkEHQPkAuUQrMcEegQIDRAH#lrd=0x45aacc28f1d464f5:0x632cd06fde32cf5,1,,,,"
              target="_blank"
            >
              <img
                src="../assets/img/home/landing/googlereviews2.jpg"
                alt=""
                class="association-logo mx-1"
              >
            </a>
            <a
              href="https://www.g2.com/products/enginehire/reviews"
              target="_blank"
            >
              <img
                src="../assets/img/home/landing/G2reviews.png"
                alt=""
                class="association-logo mx-1"
              >
            </a>
      </div>
  
        <!-- <div class="">
          <p
            class="center"
            style="font-size: 1rem; padding-top: 35px; padding-bottom: 10px"
          >
            <em>Trusted by an agency near you</em>
          </p>
          <transition
            name="logo"
            mode="out-in"
          >
            <template v-for="(agency, index) of listAgencies">
              <div
                :key="'agency-mobile-' + index"
                class="customer-logo-container"
                v-if="logoCount === index + 1"
              >
                <a
                  :href="agency.url"
                  target="_blank"
                >
                  <img
                    :src="
                      require(`../assets/img/home/customer_logos/${agency.logo}`)
                    "
                    width=""
                    height=""
                    :alt="agency.alt"
                    class="customer-logo"
                  />
                </a>
              </div>
            </template>
          </transition>
        </div> -->
      </div>
  
      <!-- <div class="web-only mb-5" style="margin-top: 75px;">
        <em
          style=""
          class="center mb-4"
        >We are proud members and sponsors of the</em>
        <div
          class="row"
          style="max-width: 650px; margin-left: auto; margin-right: auto"
        >
          <div class="col association-logo-container">
            <a
              href="https://nanny.org/"
              target="_blank"
            >
              <img
                src="../assets/img/associations/INA-Logo-2022.png"
                alt="INA International Nanny Association"
                class="association-logo"
              >
            </a>
          </div>
          <div class="col association-logo-container">
            <a
              href="https://www.nannyrelieffund.org/"
              target="_blank"
            >
              <img
                src="../assets/img/associations/nanny relief fund.png"
                alt="Nanny Relief Fund"
                class="association-logo"
                style="height: 60px; margin-top: 7px;"
              >
            </a>
          </div>
          <div class="col association-logo-container">
            <a
              href="https://theapna.org/"
              target="_blank"
            >
              <img
                src="../assets/img/associations/APNA wide.png"
                alt="APNA Association of Premier Nanny Agencies"
                class="association-logo"
                style="height: 75px; padding-left: 10px;"
              >
            </a>
          </div>
        </div>
      </div> -->

      <h4 class="center mt-5 mb-3 px-3">Want to learn more? We are excited to meet you. (:</h4>
      <!-- <div style="">
        <p
          style="max-width: 600px; display: block; margin-left: auto; margin-right: auto;"
          class="px-2 mt-4 mb-4"
        >Get a step by step run through of the process a candidate and client would take through your system, and the tools at your disposal to manage and automate everything. See for yourself exactly how some of the companies using Enginehire use it, and why they love it!</p>
      </div> -->
      <div
        class="meetings-iframe-container mb-5 web-only"
        data-src="https://meetings.hubspot.com/zuluaga/schedule-demo?embed=true"
      ></div>
      <div
        class="meetings-iframe-container mobile-only"
        data-src="https://meetings.hubspot.com/zuluaga/schedule-demo?embed=true"
      ></div>
      <!-- https://stackoverflow.com/questions/45047126/how-to-add-external-js-scripts-to-vuejs-components -->
      <script
        type="application/javascript"
        src="https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js"
      ></script>

      <!-- <div class="mobile-only mb-5">
        <em
          style=""
          class="center mb-4"
        >We're proud members & sponsors of the</em>
        <div class="col association-logo-container-mobile">
            <a
              href="https://nanny.org/"
              target="_blank"
            >
              <img
                src="../assets/img/associations/INA-Logo-2022.png"
                alt="INA International Nanny Association"
                class="association-logo"
                style="height: 50px;"
              >
            </a>
          </div>
          <div class="col association-logo-container-mobile">
            <a
              href="https://www.nannyrelieffund.org/"
              target="_blank"
            >
              <img
                src="../assets/img/associations/nanny relief fund.png"
                alt="Nanny Relief Fund"
                class="association-logo"
                style="height: 45px; margin-top: 0px;"
              >
            </a>
          </div>
        <div class="col association-logo-container-mobile">
            <a
                href="https://theapna.org/"
                target="_blank"
            >
                <img
                src="../assets/img/associations/APNA wide.png"
                alt="APNA Association of Premier Nanny Agencies"
                class="association-logo"
                style="height: 55px; padding-left: 0px;"
                >
            </a>
        </div>
      </div> -->
    </div>
  </template>
  
  <script>
  import CarouselComponent from "./CarouselComponent";
  import CarouselImageComponent from "./CarouselImageComponent";
  
  export default {
    created() {
      // Scroll the window to top on load
      window.scrollTo(0, 0); // https://stackoverflow.com/questions/50449123/vue-js-scroll-to-top-of-page-for-same-route
      window.location.replace("https://enginehire.io/au-pair-agency-software/");
    },
    components: {
      CarouselComponent,
      CarouselImageComponent,
    },
    // https://stackoverflow.com/questions/49849376/vue-js-triggering-a-method-function-every-x-seconds
    mounted: function () {
      window.setInterval(() => {
        this.incrementLogoCount();
      }, 3000);
    },
    data() {
      return {
        logoCount: 1,
        listTestimonial: [
          {
            text: "<strong>We have used so many platforms.</strong> From iCims to Bullhorn, to trying to create ones ourselves with Zoho, Asana, Monday.com, Trello, and Airtable. <strong>They just did not work for our industry.</strong> Enginhire has created a logical system that is simple to use with lots of amazing features. I am so glad we found them.",
            img: {
              src: "Ruka.png",
              alt: "Ruka Curate Tiny Treasures NYC Staffing Agency",
            },
            personInfo: "Ruka C - Co-Founder of",
            link: {
              text: "Tiny Treasures NYC",
              url: "https://www.tinytreasuresnyc.com/",
            },
          },
          // {
          //   text: "As an agency our previous experiences with other software has been less than ideal, but Enginehire has been an absolute breath of fresh air. They are <strong>loyal, reliable, and extremely quick to respond</strong> when an issue arises. They have consistently strived for the <strong>most innovative and user friendly solutions to optimize our business</strong>.",
          //   img: {
          //     src: "caroline.jpg",
          //     alt: "Caroline",
          //   },
          //   personInfo: "Caroline W - Co-founder of",
          //   link: {
          //     text: "Trusting Connections",
          //     url: "https://www.trustingconnections.com/",
          //   },
          // },
          {
            text: "When I first spoke with Enginehire I thought the price was a little steep and almost did not move forward. Ever since then <strong>the price is worth every penny.</strong> If I ever need anything updated, <strong>they respond almost immediately</strong> with a solution. They are continuously working to keep the system updated and <strong>always adding new features</strong>!",
            img: {
              src: "SarahM.png",
              alt: "Sarah Meadors Nannies Coast to Coast Staffing Agency",
            },
            personInfo: "Sarah M - Founder of",
            link: {
              text: "Nannies Coast to Coast",
              url: "https://nanniescoasttocoast.com/",
            },
          },
          {
            text: "<strong>BEST software you will find in the market for NANNY AGENCIES!</strong> The automation of the system saves so much time and the way <strong>you just need to use one software instead of having 10 software for different things.</strong> Also, they are very accommodating to your needs.",
            img: {
              src: "Alejandra.png",
              alt: "Alejandra La Lune Sitters Agency",
            },
            personInfo: "Alejandra D - Owner of",
            link: {
              text: "La Lune Sitters",
              url: "https://www.lalunesitters.com/",
            },
          },
          {
            text: "The Enginehire team was absolutely <strong>wonderful to work with; professional, dedicated, and supportive</strong>. I cannot recommend Enginehire enough if you're looking for a way to <strong>streamline your processes</strong> and work with a patient and understanding team.",
            img: {
              src: "deniz.jpg",
              alt: "Deniz Hanson Trusted Nanny Match Staffing Agency",
            },
            personInfo: "Deniz H - Founder of",
            link: {
              text: "Trusted Nanny Match",
              url: "https://www.trustednannymatch.com/",
            },
          },
          {
            text: "The Enginehire Team have been excellent to work with and provide <strong>phenomenal customer service</strong>. Their <strong>knowledge of the industry and individual customization is unparalleled</strong> and their platform has revolutionized the way that my team does business.",
            img: {
              src: "lydia.jpg",
              alt: "Lydia Sommet Nannies Staffing Agency",
            },
            personInfo: "Lydia B - Owner of",
            link: {
              text: "Sommet Nannies",
              url: "https://www.sommetnannies.com/",
            },
          },
          {
            text: "I should have done this months ago. <strong>I waited out of fear and concern that automation wouldn't be the right fit for such a personalized service. I was so wrong</strong> and I'm kicking my past self for waiting! Any agency that is on the fence or considering Enginehire should just take the plunge. It is worth every penny!",
            img: {
              src: "ameliaG2.png",
              alt: "Amelia Nannies Agency",
            },
            personInfo: "Amelia D - Owner of",
            link: {
              text: "Amelia's Nannies",
              url: "https://www.ameliasnannies.com/",
            },
          },
          {
            text: "I have used two other management platforms and I can tell you that Enginehire is the best. Want a one-stop shop? You can match people to jobs, build resumes directly from their profiles, and so much more in seconds. <strong>Enginehire has saved me money by saving me time.</strong>",
            img: {
              src: "debra.jpg",
              alt: "Debra Elite Family Care Staffing Agency",
            },
            personInfo: "Debra F - Owner of",
            link: {
              text: "Elite Family Care",
              url: "https://elitefamilycare.com/",
            },
          },
          {
            text: "<strong>I consulted with Enginehire before my agency was even officially launched.</strong> They helped me greatly by providing me with an internal and external-facing system for candidates to apply on my site. Most agency owners I speak with either use Enginehire currently or they are making the switch over to Enginehire from another platform.",
            img: {
              src: "alison_myhouseholdmanaged.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
            personInfo: "Alison G - Owner of",
            link: {
              text: "My Household Managed",
              url: "https://myhouseholdmanaged.com/",
            },
          },
        ],
        listClientReg: [
            {
            img: {
              src: "aupair/languages.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          },
          {
            img: {
              src: "aupair/familytable.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          }
        ],
        listClientMeeting: [
            {
            img: {
              src: "aupair/meetingbooking.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          },
          {
            img: {
              src: "aupair/sidebyside.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          }
        ],
        listClientProfile: [
          {
            img: {
              src: "aupair/familyphoto.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          },
          {
            img: {
              src: "aupair/clientdashboard.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          },
          {
            img: {
              src: "aupair/signature.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          },
          {
            img: {
              src: "aupair/paymentinfo.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          }
        ],
        listJobPosting: [
            {
            img: {
              src: "aupair/jobboard.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          },
          {
            img: {
              src: "aupair/jobposting.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          }
        ],
        listCandidatePortfolios: [
            {
            img: {
              src: "aupair/candidatetable.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          },
          {
            img: {
              src: "aupair/candidateportfolio.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          },
          {
            img: {
              src: "aupair/candidateapplication.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          }
        ],
        listCandidatePresentation: [
            {
            img: {
              src: "aupair/candidatepresentation.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          },
          {
            img: {
              src: "aupair/chat.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          }
        ],
        listCompletePlacement: [
            {
            img: {
              src: "aupair/extendoffer.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          },
          {
            img: {
              src: "aupair/todo.png",
              alt: "Alison My Household Managed Staffing Agency",
            },
          }
        ],


        listAgencies: [
          {
            url: "https://tlcforkids.com/",
            logo: "tlcsmall.jpg",
            alt: "TLC For Kids Staffing Agency",
          },
          {
            url: "https://www.preferredchildcare.com/",
            logo: "PreferredChildCareLogo.png",
            alt: "Preferred Child Care Staffing Agency",
          },
          {
            url: "https://www.themtotoagency.com/",
            logo: "mtoto.png",
            alt: "The Mtoto Childcare Staffing Agency",
          },
          // {
          //   url: "https://nannyagency.com/",
          //   logo: "PhiladelphiaNannyNetwork.jpg",
          //   alt: "Philadelphia Nanny Network Agency",
          // },
          {
            url: "https://www.grapevineplacementagency.com/",
            logo: "Grapevine Nannies and Domestics full color logo.png",
            alt: "Grapevine Placement Agency",
          },
          {
            url: "https://www.mbfagency.com/",
            logo: "moms-best-friend.jpg",
            alt: "Mom's Best Friend Staffing Agency",
          },
          // {
          //   url: "https://www.mygirlfri.com/",
          //   logo: "MGF-logo-with-text2-300x300.jpg",
          //   alt: "My Girl Friday Staffing Agency",
          // },
  
          // {
          //   url: "https://trustingconnections.com/",
          //   logo: "trusting_connections-emblem_vector-gold.svg",
          //   alt: "Trusting Connections",
          // },
          {
            url: "https://www.windsorhousenannies.com/",
            logo: "whn.png",
            alt: "Windsor House Nannies Staffing Agency",
          },
          // {
          //   url: "https://www.thewellingtonagency.com/",
          //   logo: "the-wellington-agency-logo.png",
          //   alt: "The Wellington Agency",
          // },
          
          {
            url: "https://unitednanny.org/",
            logo: "United+Nanny+Crest.jpg",
            alt: "United Nanny Agency",
          },
          
          {
            url: "https://www.pbjnanny.com/",
            logo: "pbj.png",
            alt: "PB+J Collective Staffing Agency",
          },
          {
            url: "https://nannybydesign.com/",
            logo: "nannybydesign.png",
            alt: "Nanny By Design Agency",
          },
          
          {
            url: "https://anewenglandnanny.com",
            logo: "A-New-England-Nanny-Logo.png",
            alt: "A New England Nanny",
          },
          {
            url: "https://www.lovingcarehomeservices.com/",
            logo: "LovingCareColor.png",
            alt: "Loving Care Home Services Agency",
          },
          {
            url: "https://myhouseholdmanaged.com/",
            logo: "MHM_Logo_Main_clear.png",
            alt: "My Household Managed Staffing Agency",
          },
          // {
          //   url: "http://littleonesnannyagency.com/",
          //   logo: "littleones.jpg",
          //   alt: "Little Ones Nanny Agency",
          // },
          // {
          //   url: "https://apex-social.org/us",
          //   logo: "logo_apex_basic_V2_600px.jpg",
          //   alt: "Apex Social",
          // },
          // {
          //   url: "https://www.ameliasnannies.com/",
          //   logo: "ameilas-nannies.png",
          //   alt: "Amelia's Nannies",
          // },
          {
            url: "https://washburnagency.com/",
            logo: "washburn-share-logo (1).jpg",
            alt: "The Washburn Agency",
          },
          {
            url: "https://www.lalunesitters.com/",
            logo: "LogoLaLuneSittersvector_whitefill.svg",
            alt: "La Lune Sitters Agency",
          },
          {
            url: "http://www.oliveyounanny.com/",
            logo: "OYN-logo-2016_copy_317757b7-57e2-47bc-8bf0-66ccdab347ee.jpg",
            alt: "Olive You Nanny Agency",
          },
          {
            url: "https://elitefamilycare.com/",
            logo: "elitefamilycare-logo.png",
            alt: "Elite Family Care Staffing Agency",
          },
          // {
          //   url: "https://nanniesofthewoodlands.com/",
          //   logo: "nanniesofthewoodlands_busdir.jpg",
          //   alt: "Nannies of the Woodlands",
          // },
          // {
          //   url: "https://www.manhattannannies.com/",
          //   logo: "manhattan_nannies.jpg",
          //   alt: "Manhattan Nannies",
          // },
          {
            url: "https://www.nashvillenannyagency.com/",
            logo: "NNA.jpg",
            alt: "Nashville Nanny Agency",
          },
          {
            url: "https://mansfielddomestics.com/",
            logo: "Main Logo Green and Yellow.png",
            alt: "Mansfield Domestics Staffing Agency",
          },
          {
            url: "https://www.tinytreasuresnyc.com/",
            logo: "tiny treasureshi res.jpg",
            alt: "Tiny Treasures NYC Staffing Agency",
          },
          {
            url: "https://www.nannyportugal.com/",
            logo: "Nanny Portugal Agency Logo Blue.png",
            alt: "Nanny Portugal Staffing Agency",
          },
          {
            url: "https://www.sommetnannies.com/",
            logo: "SOMMET_PRIMARY_CHARCOAL.png",
            alt: "Sommet Nannies Staffing Agency",
          },
          {
            url: "https://www.trustednannymatch.com/",
            logo: "TNM-Monogram-DarkNavy.svg",
            alt: "Trusted Nanny Match Staffing Agency",
          },
          {
            url: "https://pinknannies.com/",
            logo: "PinkNannies-Circle.svg",
            alt: "Pink Nannies Staffing Agency",
          },
          {
            url: "http://minannyauthority.com/",
            logo: "logo-minanny.png",
            alt: "Michigan Nanny Authority Agency",
          },
          {
            url: "https://thenannyhub.com/",
            logo: "thenannyhub.png",
            alt: "The Nanny Hub Staffing Agency",
          },
          {
            url: "https://makingmemoriesagency.com/",
            logo: "making-memories.jpg",
            alt: "Making Memories Agency",
          },
          
          {
            url: "https://familyfirsthsa.com/",
            logo: "familyfirst.png",
            alt: "Family First Staffing Agency",
          },
  
          // Removed this row of logos
          // {
          //   url: "https://www.helloclementines.com/",
          //   logo: "hello-clementines.png",
          //   alt: "Hello Clementines",
          // },
          // {
          //   url: "https://www.406nannies.com/",
          //   logo: "406Nannies-FullColor-2.png",
          //   alt: "406 Nannies",
          // },
          // {
          //   url: "https://www.jacksonholenannies.com/",
          //   logo: "jhn-logo-horizontal-1.png",
          //   alt: "Jackson Hole Nannies",
          // },
          // {
          //   url: "https://extra-arms.com/",
          //   logo: "extra-arms.png",
          //   alt: "Extra Arms",
          // },
  
          {
            url: "https://mollycoddlers.net/",
            logo: "mollycoddlers.png",
            alt: "Mollycoddlers Childcare Staffing Agency",
          },
          {
            url: "https://www.atxnannynetwork.com/",
            logo: "austin_nanny_network.png",
            alt: "Austin Nanny Network Agency",
          },
          {
            url: "https://www.portlandnanny.com/",
            logo: "portland-nanny-logo.png",
            alt: "Portland Nanny Agency",
          },
          // {
          //   url: "https://www.mannyandme.com/",
          //   logo: "mannyandme.png",
          //   alt: "Manny & Me",
          // },
          {
            url: "https://www.ateasefamilysolutions.com/",
            logo: "at-ease_new-logo_300ppi-PNG.png",
            alt: "At Ease Family Solutions",
          },
        ],
        listFeatures: [
        {
            icon: "beautifulwebsite.svg",
            title: "Web Forms",
            text: "Custom inquiry forms, embedded directly into your website",
            alt: "Nanny Staffing Agency Website"
          },
          {
            icon: "calendar.svg",
            title: "Scheduling",
            text: "Easily book meetings and consultations, no more “when are you free?” emails",
            alt: "Staffing Agency Meeting Scheduling"
          },
          {
            icon: "document.svg",
            title: "Signatures",
            text: "Built in documents and e-signatures - no need for PDFs or DocuSign",
            alt: ""
          },
        {
            icon: "booksapple_blue.svg",
            title: "Classes",
            text: "Offer classes, courses and training, easily bookable through your website",
            alt: "Nanny Agency App"
          },
          
        //   {
        //     icon: "briefcase.svg",
        //     title: "Beautiful Job Postings",
        //     text: "Seamlessly collect applications and attract the best candidates",
        //     alt: "Nanny Staffing Agency Job Board"
        //   },
        //   {
        //     icon: "phonetracking.svg",
        //     title: "Shift Management",
        //     text: "Manage schedules and fill short term placements in seconds",
        //     alt: "Pro Sitter App"
        //   },
          {
            icon: "SMS.svg",
            title: "Auto Email+SMS",
            text: "Spend time actually talking to people - no more rewriting the same thing",
            alt: "Staffing Agency Text Messaging"
          },
          
          {
            icon: "creditcards.svg",
            title: "Payments",
            text: "Built in payment processing - no more chasing clients to pay invoices",
            alt: "Stripe Quickbooks Payment Processing"
          },
          {
            icon: "blogwriting.svg",
            title: "Notes",
            text: "Consultation calls, meetings, etc. - take all your notes, all in one place",
            alt: "Staffing Agency Reference Checking"
          },
          {
            icon: "analytics.svg",
            title: "Analytics",
            text: "Understand what’s working, what’s not, and how to grow your business further",
            alt: "Staffing Agency Analytics"
          },
        ],
      };
    },
    methods: {
      incrementLogoCount() {
        if (this.logoCount == this.listAgencies.length) {
          this.logoCount = 1;
        } else {
          this.logoCount += 1;
        }
      },
    },
  };
  </script>
  
  <style>
  .landing {
    /* height: 100vh; */
    /* background-color: var(--skyblue); */
    /* background-color: var(--coredarkcolor); */
    /* background-color: #fcbf67; */
    width: 100%;
  
    /* height: 75vh; */
    /* height: 70vh; */
    /* min-height: 550px; */
    /* padding-left: 5%; */
    /* padding-right: 5%; */
  
    /* background-color: white;
    background: url("../assets/img/home/landing/AdobeStock_161673435_shaded6.1_compressed.png")
      left center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat; */
  
    /* background-position: left top; */
  }

  .dashboardimage {
    /* height: 100vh; */
    /* background-color: var(--skyblue); */
    background-color: var(--coredarkcolor);
    /* background-color: #fcbf67; */
    width: 100%;
  
    /* height: 75vh; */
    /* height: 70vh; */
    height: 100%;
    /* min-height: 550px; */
    /* padding-left: 5%; */
    /* padding-right: 5%; */
  
    background-color: white;
    background: url("../assets/img/newborn/client_dashboard.png") left
      bottom;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .mapimage {
    /* height: 100vh; */
    /* background-color: var(--skyblue); */
    background-color: var(--coredarkcolor);
    /* background-color: #fcbf67; */
    width: 100%;
  
    /* height: 75vh; */
    /* height: 70vh; */
    height: 100%;
    /* min-height: 550px; */
    /* padding-left: 5%; */
    /* padding-right: 5%; */
  
    background-color: white;
    background: url("../assets/img/newborn/master_calendar.png") center
      bottom;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
  }

  .dashboardimage {
    /* height: 100vh; */
    /* background-color: var(--skyblue); */
    background-color: var(--coredarkcolor);
    /* background-color: #fcbf67; */
    width: 100%;
  
    /* height: 75vh; */
    /* height: 70vh; */
    height: 100%;
    /* min-height: 550px; */
    /* padding-left: 5%; */
    /* padding-right: 5%; */
  
    background-color: white;
    background: url("../assets/img/home/portfoliomanager/candidate_dashboard4.jpg") left
      bottom;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
  }
  
  .momimage {
    /* height: 100vh; */
    /* background-color: var(--skyblue); */
    background-color: var(--coredarkcolor);
    /* background-color: #fcbf67; */
    width: 100%;
  
    /* height: 75vh; */
    /* height: 70vh; */
    min-height: 550px;
    /* padding-left: 5%; */
    /* padding-right: 5%; */
  
    background-color: white;
    background: url("../assets/img/home/landing/AdobeStock_392855683.jpg") left
      center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
  }
  
  .seniorimage {
    /* height: 100vh; */
    /* background-color: var(--skyblue); */
    background-color: var(--coredarkcolor);
    /* background-color: #fcbf67; */
    width: 100%;
  
    /* height: 75vh; */
    /* height: 70vh; */
    min-height: 550px;
    /* padding-left: 5%; */
    /* padding-right: 5%; */
  
    background-color: white;
    background: url("../assets/img/home/landing/AdobeStock_423398211.jpg") left
      center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat;
  }
  
  .mobile-landing {
    /* height: 100vh; */
    /* background-color: var(--shopify); */
    /* background-color: #fcbf67; */
    width: 100%;
  
    /* height: 75vh; */
    /* height: 70vh;  */
    /* min-height: 550px; */
    padding-left: 0;
    padding-right: 0;
  
    /* background-color: var(--coredarkcolor); */
    /* background-image: url('https://thewallpaper.co//wp-content/uploads/2016/10preview/goku-universal-hero-backgrounds-photo-hd-wallpapers-4k-amazing-desktop-wallpapers-mac-desktop-images-widescreen-1080p-digital-photos-1920x1080.jpg'); */
    /* background-image: url('../assets/img/AdobeStock_272829109_Preview2.png'); */
    /* background-image: url('../assets/img/AdobeStock_95578556_Preview_crop1.jpeg'); */
    /* background: url('../assets/img/AdobeStock_95578556_Preview_crop1.jpeg') left center; */
    /* background: url('../assets/img/landing/AdobeStock_95578556_crop1.jpeg') left center; */
    /* background: url('../assets/img/landing/employer/AdobeStock_95578556_crop1_resize1.jpeg') left center; */
    
    /* background: url("../assets/img/home/landing/AdobeStock_161673435_shaded6.1_compressed.png")
      center center;
    -webkit-background-size: cover;
    -moz-background-size: cover;
    -o-background-size: cover;
    background-size: cover;
    background-repeat: no-repeat; */
  
    /* background-position: left top; */
  }
  
  .customer-logo-container {
    text-align: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding-top: 7px;
    padding-bottom: 38px;
  }
  .customer-logo {
    height: 70px;
    /* max-width: 100px; */
  }
  
  .association-logo-container {
    text-align: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding-top: 7px;
    padding-bottom: 38px;
  }
  .association-logo-container-mobile {
    text-align: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    padding-top: 7px;
    padding-bottom: 25px;
  }
  .association-logo {
    height: 75px;
    /* max-width: 100px; */
  }
  
  .feature-card {
    padding-top: 20px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    /* margin-left: 10px; */
    /* margin-right: 10px; */
    /* max-width: 20%; */
    /* width: 99%; */
    /* border: 1px solid gray; */
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
    text-align: center;
    margin-left: auto;
    margin-right: auto;
  }
  .card {
    padding-top: 30px;
    padding-bottom: 20px;
    padding-left: 20px;
    padding-right: 20px;
    /* margin-left: 10px; */
    /* margin-right: 10px; */
    /* max-width: 20%; */
    /* width: 99%; */
    /* border: 1px solid gray; */
    /* box-shadow: 0 .25rem 0.5rem rgba(0,0,0,.15); */
    text-align: center;
    margin-top: 25px;
    /* margin-left: auto; */
    /* margin-right: auto; */
  
    border: none;
  }
  .card-body {
    padding: 0.1rem;
  }
  .feature-card img {
    text-align: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: 170px;
  }
  .card img {
    /* text-align: center;
    display: block;
    margin-left: auto;
    margin-right: auto;
    height: 170px; */
  }
  .card-img-top {
    /* text-align: center; */
    display: block;
    margin-left: 0 !important;
    margin-right: auto !important;
    text-align: left;
    float: left;
    height: 70px;
    margin-bottom: 10px;
  }
  .feature-img {
    height: 70px;
    display: block;
    margin-right: auto;
    margin-bottom: 10px;
  }
  .feature-card-title {
    margin-top: 15px;
  }
  .card-title {
    line-height: 1.3;
    text-align: left;
  }
  .card-text {
    text-align: left;
  }
  
  .testimonial-card {
    /* background-color: #eaf4fe; */
  }
  .testimonial-card img {
    /* height: 150px;
    width: 150px;
    border-radius: 50%; */
  }
  
  .customer-image {
    border-radius: 50%;
    width: 150px;
  }
  
  .visit-platform-button {
    margin-top: 33px;
    margin-bottom: 12px;
  }
  
  .logo-enter {
    opacity: 0;
  }
  .logo-enter-active {
    transition: opacity 1s;
  }
  .logo-leave {
  }
  .logo-leave-active {
    transition: opacity 1s;
    opacity: 0;
  }
  
  /* ------------------- SMALL -------------------- */
  @media (max-width: 768px) {
    .card {
      /* margin-top: 20px; */
      margin-top: 2px;
    }
    .card-deck .card {
      margin-bottom: 2px;
    }
  }
  
  .card-image-container {
    text-align: center;
    margin: 1rem 0;
  }
  
  .card-image {
    border-radius: 0%;
    text-align: left;
  }
  
  .medium-carousel {
    display: none;
  }
  .big-carousel {
    display: inherit;
  }
  
  .small-carousel {
    display: inherit;
    margin: 0 40px;
  }
  .tiny-carousel {
    display: none;
  }
  
  .features-summary-section {
    display: flex;
    flex-wrap: wrap;
    margin-top: 5px;
    margin-bottom: 10px;
  }
  
  .feature-container {
    flex-basis: 25%;
    padding-left: 30px;
    padding-right: 30px;
  }
  
  @media (max-width: 1280px) {
    .medium-carousel {
      display: inherit;
    }
    .big-carousel {
      display: none;
    }
    .feature-container {
      flex-basis: 25%;
    }
  }
  
  @media (max-width: 960px) {
    .feature-container {
      flex-basis: 33.33%;
    }
  }
  
  @media (max-width: 768px) {
    .features-summary-section {
      margin-bottom: 10px;
    }
    .feature-container {
      flex-basis: 50%;
    }
  }
  
  @media (max-width: 575px) {
    .feature-container {
      flex-basis: 100%;
    }
  }
  
  @media (max-width: 460px) {
    .small-carousel {
      display: none;
    }
    .tiny-carousel {
      display: inherit;
    }
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/AuPairAgencySoftware.vue